import { lazy } from 'react';
import authRoles from '@/app/auth/authRoles';

const UnsubscribePage = lazy(() => import('./Unsubscribe'));

const UnsubscribeConfig = {
  settings: {
    layout: {
      config: {
        mode: 'fullwidth',
        scroll: 'content',
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.AllUsers,

  routes: [
    {
      path: 'unsubscribe/:token',
      element: <UnsubscribePage />,
    },
  ],
};

export default UnsubscribeConfig;
